// API Configuration
export const API_CONFIG = {
  // Update this URL to match your backend API
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
  
  // Timeout for requests (in milliseconds)
  timeout: 30000,
  
  // Enable credentials for httpOnly cookies
  withCredentials: true,
};
